import { TECH_STACK_ICONS } from '../../../constants';

export const TechStackIcons = ({ tags }) => (
  <div className="pf-modal-tags">
    {tags.map((tag) => {
      const tech = TECH_STACK_ICONS[tag];

      return (
        <span key={tag} className="pf-tag" title={tag}>
          {tech?.logo ? (
            <img src={tech.logo} alt="" aria-hidden="true" />
          ) : (
            <span className="pf-tag-initials" aria-hidden="true">{tech?.short || tag.slice(0, 2).toUpperCase()}</span>
          )}
          <span>{tag}</span>
        </span>
      );
    })}
  </div>
);
